import React from 'react';
import { useNavigate } from 'react-router-dom';

const styles = {
  page: {
    minHeight: '100vh',
    backgroundColor: '#f8fafc',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    border: '1px solid #e2e8f0',
    padding: '3rem 2.5rem',
    width: '100%',
    maxWidth: '480px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
    textAlign: 'center',
  },
  logo: {
    fontSize: '1.75rem',
    fontWeight: '700',
    color: '#01696F',
    marginBottom: '2rem',
  },
  errorCode: {
    fontSize: '5rem',
    fontWeight: '800',
    color: '#01696F',
    lineHeight: '1',
    marginBottom: '1rem',
  },
  heading: {
    fontSize: '1.5rem',
    fontWeight: '700',
    color: '#1e293b',
    marginBottom: '0.75rem',
  },
  message: {
    color: '#64748b',
    fontSize: '0.95rem',
    marginBottom: '2rem',
    lineHeight: '1.6',
  },
  btn: {
    display: 'inline-block',
    padding: '0.75rem 1.75rem',
    backgroundColor: '#01696F',
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '0.95rem',
    fontWeight: '600',
    cursor: 'pointer',
  },
};

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logo}>BragSheet</div>
        <div style={styles.errorCode}>404</div>
        <h1 style={styles.heading}>Page Not Found</h1>
        <p style={styles.message}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        <button style={styles.btn} onClick={() => navigate('/')}>
          Go to Dashboard
        </button>
      </div>
    </div>
  );
}
